import { Route, Routes } from "react-router-dom";
import { Login } from "./Login";
import { Register } from "./Register";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";
import { MerchantRegister } from "./MerchantRegister";

export const AuthRoutes = () => {
  const { googleClientId } = useSelector(
    (state: RootState) => state.appData.appData
  );

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="register/:code?" element={<Register />} />
        <Route path="register/merchant" element={<MerchantRegister />} />
      </Routes>
    </GoogleOAuthProvider>
  );
};
